import React, {FC} from 'react';
import styled from 'styled-components';

import {SelectedConversationsDetails} from '../../../../libs/inboxes/business/src/cells/conversations';
import {TicketStatusName} from '../../../../libs/inboxes/ui/src/ticketing/ticketStatusName';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {TicketStatusIndicator} from './ticketStatusIndicator';

/*
 * Style.
 */

const ContainerDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/*
 * Props.
 */

interface TicketStatusCellProps {
  selectionDetails: SelectedConversationsDetails;
}

/*
 * Component.
 */

export const TicketStatusCell: FC<TicketStatusCellProps> = (props) => {
  const {indicatedTicketStatus, indicatedTicketStatusCategory, ticketStatuses} = props.selectionDetails;

  const renderLabel = () => {
    if (indicatedTicketStatus) {
      return <TicketStatusName tagId={indicatedTicketStatus.tagId} />;
    }

    return <Trans id="ticket-status-cell-multiple-statuses">{ticketStatuses.length} statuses</Trans>;
  };

  const renderIndicator = () => {
    if (indicatedTicketStatusCategory) {
      return <TicketStatusIndicator category={indicatedTicketStatusCategory} />;
    }

    return <Icon name="changeStatusSmall" />;
  };

  return (
    <ContainerDiv>
      {renderIndicator()}
      {renderLabel()}
    </ContainerDiv>
  );
};
